import Vue from 'vue/dist/vue.esm.js';
import {priceConverter} from "../utility/priceConverter";

Vue.component('cart', {
    template: `#cart`,
    delimiters: ['[[', ']]'],
    props: {
        exchangeRate: {
            required: true,
            type: Number,
        },
        exchangeRateMode: {
            required: true,
            type: Number,
        },
        convertMode: {
            required: true,
            type: Number,
        },
        initialCart: {
            required: true,
            type: Object,
        },
        hasUser: {
            required: true,
            type: Number,
        },
        stores: {
            required: false,
            type: Array,
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        removeRowUrl: {
            required: true,
            type: String,
        },
        incrementUrl: {
            required: true,
            type: String,
        },
        decrementUrl: {
            required: true,
            type: String,
        },
        changeQuantityUrl: {
            required: true,
            type: String,
        },
        changeStoreUrl: {
            required: true,
            type: String,
        },
        clearCartUrl: {
            required: true,
            type: String,
        },
        deliveryOption: {
            required: false,
            type: Object|Boolean,
        }
    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip('dispose');
        $('[data-toggle="tooltip"]').tooltip();
    },

    mounted() {
        EventManager.listen('item-added', this.cartUpdated);
        EventManager.listen('item-removed', this.cartUpdated);
        EventManager.listen('store-change', this.cartUpdated);
        EventManager.listen('quantity-change', this.cartUpdated);

        this.selectedStore = this.cart.selectedStore;
        
        this.checkForEmptyCart();
    },

    data() {
        return {
            cart: this.initialCart,
            selectedStore: null,
            stockFilter: 'all',
            quantityAlert: {
                visible: false,
                productName: '',
            },
        }
    },

    methods: {
        cartUpdated(data) {
            this.cart = JSON.parse(data);
            this.selectedStore = this.cart.selectedStore;
        },

        removeRow(row) {
            let _self = this;
            $.ajax({
                data: {id: row.id},
                url: _self.removeRowUrl,
                method: 'POST',
                success: function (result) {
                    EventManager.fire('item-removed', result.cart);

                    let event = {
                        event: 'eec.remove',
                        eventData: result.variant,
                        action: 'CartPage',
                    }
                    EventManager.fire('gtm-event',event);
                    _self.checkForEmptyView();
                },
            });
        },
        addVariantQuantity(row) {
            let _self = this;
            $.ajax({
                data: {id: row.variantId, storeId: row.store.id},
                url: _self.incrementUrl,
                method: 'POST',
                success: function (result) {
                    if(result.success !== false){
                        _self.quantityAlert.visible = false;
                        EventManager.fire('item-added', result.cart);

                        let event = {
                            event: 'eec.add',
                            eventData: result.variant,
                            unique_event_id: result.unique_event_id,
                            action: 'CartPage',
                        }

                        EventManager.fire('gtm-event', event);

                    }else{
                        _self.quantityAlert.visible = true;
                        _self.quantityAlert.productName = row.name;
                    }
                },
            });
        },
        decrementVariantQuantity(row) {
            let _self = this;
            $.ajax({
                data: {id: row.id},
                url: _self.decrementUrl,
                method: 'POST',
                success: function (result) {
                    _self.quantityAlert.visible = false;
                    EventManager.fire('item-removed', result.cart);
                    let event = {
                        event: 'eec.remove',
                        eventData: result.variant,
                        action: 'CartPage',
                    }
                    EventManager.fire('gtm-event',event);
                    _self.checkForEmptyCart();
                },
            });
        },
        changeCartStore() {
            let _self = this;
            $.ajax({
                data: {id: _self.selectedStore.id},
                url: _self.changeStoreUrl,
                method: 'POST',
                success: function (result) {
                    EventManager.fire('store-change', result.cart);
                },
            });
        },

        incrementRowQuantity(row) {
            if (row.quantity > row.variantMaxQuantity) {
                return;
            }
            this.addVariantQuantity(row);
        },
        changeRowQuantity(row){

            let _self = this;
            $.ajax({
                data: {id: row.id, quantity: row.quantity},
                url: _self.changeQuantityUrl,
                method: 'POST',
                success: function (result) {
                    if(result.cart){
                        EventManager.fire('quantity-change', result.cart);
                    }
                },
            });
        },
        removeProductsPerStockStatus() {
            const confirmMessage = event.target.dataset.confirmMessage;
            if (!confirm(confirmMessage)) {
                return;
            }
            this.selectedStoreRows.forEach((product) => {
                if (this.stockFilter === 'not_enough_quantity' && product.notЕnoughQuantity) {
                    this.removeRow(product);
                } else if (this.stockFilter === 'out_of_stock' && !product.inStock && !product.notЕnoughQuantity) {
                    this.removeRow(product);
                }
            });
            this.stockFilter = 'all';
        },
        hasProductsByStockStatus(status) {
            if (status === 'all') {
                return false;
            }

            const rowsByStockStatus = this.selectedStoreRows.filter(row => {
                if (status === 'in_stock' && row.inStock) {
                    return true;
                }
                if (status === 'not_enough_quantity' && row.notЕnoughQuantity) {
                    return true;
                }
                if (status === 'out_of_stock' && !row.inStock && !row.notЕnoughQuantity) {
                    return true;
                }
                return false;
            });

            return rowsByStockStatus.length === 0;
        },
        decrementQuantity(row) {
            if (row.quantity === 1) {
                return;
            }
            this.decrementVariantQuantity(row);
        },
        formattedRowPrice(row, separator = '/') {
            return this.formattedPrice(row.totalPrice, separator);
        },
        formattedPrice(price, separator = '/', onlyLocalePrice = false) {
            return priceConverter(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, separator, this.locale, onlyLocalePrice);
        },

        outOfStockProducts(){
            return this.selectedStoreRows.filter(row => !row.inStock);
        },

        concatenateAttributeValues(attributes) {
            let str = '';
            for (let [index,attribute] of attributes.entries()) {
                if(index !== 0){
                    str += ', '
                }
                if(attribute.showUnit){
                    str += attribute.unit + ' x '
                }
                str +=  ' ' + attribute.value;

            }
            return str;
        },
        selectStore(store){
            this.selectedStore = store;
            this.changeCartStore();
        },
        clearCart(){
            let _self = this;
            $.ajax({
                data: {id: _self.selectedStore.id},
                url: _self.clearCartUrl,
                method: 'POST',
                success: function (result) {
                    EventManager.fire('item-removed', result.cart);
                    _self.checkForEmptyCart();
                },
            });
        },
        hasRowsForStore(store){
            const rows = Array.isArray(this.cart.rows)
            ? this.cart.rows
            : Object.values(this.cart.rows); // ✅ convert object-like to array

            if(rows.length == 0){
                return false;
            }

            return rows.filter(row => row.store.id === store.id).length > 0;
        },
        tryAutoSelectDifferentStore() {
            if (this.selectedStore) {
                let _self = this;
                var otherStoreRows = this.cart.rows.filter(row => row.store.id != _self.selectedStore.id);
                if (otherStoreRows.length > 0) {
                    this.selectedStore = otherStoreRows[0].store;
                    this.changeCartStore();
                }
            }
        },
        checkForEmptyCart(){
            if(!this.hasRowsForStore(this.selectedStore)){
                this.tryAutoSelectDifferentStore();
            }
        },
        checkForEmptyView(){
          if(this.filteredStoreRows.length === 0){
              this.stockFilter = 'all';
          }
        },
    },

    computed: {
        formattedTotal() {
            return this.formattedPrice(this.cart.total)
        },
        selectedStoreRows(){
            let _self = this;
            const rows = Array.isArray(this.cart.rows)
            ? this.cart.rows
            : Object.values(this.cart.rows);

            if(!_self.selectedStore){
                return rows;
            }
            if(rows.length == 0){
                return [];
            }

            return rows.filter(row => row.store.id === _self.selectedStore.id);
        },
        storeRowCounts() {
            const rows = Array.isArray(this.cart.rows)
                ? this.cart.rows
                : Object.values(this.cart.rows);  
    
            return rows.reduce((acc, row) => {
                const storeId = row.store.id;
                if (!acc[storeId]) {
                    acc[storeId] = 0;
                }
                acc[storeId]++;
                return acc;
            }, {});
        },
        formattedOriginalTotal() {
            return this.formattedPrice(this.cart.totalPriceAfterDiscount)
        },
        formattedDiscount() {
            return '-' + this.formattedPrice(this.cart.discount);
        },
        storeName() {
            return this.selectedStore ? this.selectedStore.name : null;
        },
        filteredStoreRows() {
            let rows = this.selectedStoreRows;

            if (this.selectedStore) {
                rows = rows.filter(row => row.store.id === this.selectedStore.id);
            }

            if (!this.stockFilter) {
                return rows;
            }
            return this.selectedStoreRows.filter(row => {
                if (this.stockFilter === 'in_stock') {
                    return row.inStock;
                }
                if (this.stockFilter === 'not_enough_quantity') {
                    return row.notЕnoughQuantity;
                }
                if (this.stockFilter === 'out_of_stock') {
                    return !row.inStock && !row.notЕnoughQuantity;
                }
                return true;
            });
        },

    }
});